import { useContext } from "react";
import { RecommendedDosageContext } from "./RecommendedDosageProvider";

export function useRecommendedDosage() {
  const recommended = useContext(RecommendedDosageContext);

  if (recommended === null) {
    return;
  }

  return recommended;
}
